import React from 'react'// eslint-disable-line
import PropTypes from 'prop-types';
import {currencyFormatter} from '../../utils/helpers';

export const SberbankInfo = ({gradesList, operation, classStyles}) => (
  gradesList.map(grade => (
    <p key={grade.grade} className={classStyles}><b>{currencyFormatter(grade[operation])}</b> {grade.grade}</p>
  ))
);

SberbankInfo.defaultProps = {
  classStyles: ''
};

SberbankInfo.propTypes = {
  gradesList: PropTypes.arrayOf(PropTypes.shape({
    buy: PropTypes.number,
    grade: PropTypes.string,
    sell: PropTypes.number
  })).isRequired,
  operation: PropTypes.string.isRequired,
  classStyles: PropTypes.string
};
